module.exports = __webpack_public_path__ + "media/images/cover-banner-contact-us-2-8e95673b089bf2f7f22ccee692f4d4b4.webp";